<div class="main">
  <icn-dropdown
    (selectedValueChange)="onSelectPlatform($event)"
    [placeholder]="'Add Platforms'"
  >
    <!-- <icn-dropdown-item title="Facebook" [value]="1"></icn-dropdown-item> -->
    <!--<icn-dropdown-item title="Youtube" [value]="2"></icn-dropdown-item>-->
    <!--<icn-dropdown-item title="MyWebsite" [value]="3"></icn-dropdown-item>-->
    <!--<icn-dropdown-item title="MyApp" [value]="4"></icn-dropdown-item>-->
    <icn-dropdown-item title="HLS" [value]="5"></icn-dropdown-item>
    <icn-dropdown-item title="PUSH" [value]="6"></icn-dropdown-item>
  </icn-dropdown>
  <div
    class="svg-icon"
    inlineSVG="/assets/icons/add-account.svg"
    (click)="addPlatform()"
  ></div>
</div>

<div *ngFor="let channelPlatform of channelPlatforms">
  <icn-platforms-collapsible
    [(label)]="channelPlatform.displayLabel"
    (remove)="onRemovePlatform(channelPlatform)"
    [isEditable]="isCustomPlatform(channelPlatform)"
    [(isActive)]="channelPlatform.isActive"
  >
    <facebook-platform
      *ngIf="isFacebookPlatform(channelPlatform)"
    ></facebook-platform>
    <custom-platform
      *ngIf="isCustomPlatform(channelPlatform)"
      [platform]="$any(channelPlatform)"
      [channelCodecs]="channelCodecs"
      [channelInfo]="channelInfo"
      [allEdgeServers]="allEdgeServers"
      (saveCodec)="saveCodec.emit($event)"
      (edgeServerChanged)="_bindEdgePreviewServers()"
      [burnSubtitlesToVideo]="burnSubtitlesToVideo"
    ></custom-platform>
  </icn-platforms-collapsible>
</div>
<div class="preview-settings">
  <div class="ts-action">
    <span class="label">WebRTC Edge Server:</span>

    <icn-dropdown
      [large]="true"
      [allowMultiple]="false"
      [(selectedValue)]="channelInfo.webRtcPreviewEdgeServerId"
    >
      <icn-dropdown-item
        *ngFor="let edgeServer of relevantFeedPreviewEdgeServers"
        [value]="edgeServer.id"
        [title]="edgeServer.name"
      >
      </icn-dropdown-item>
    </icn-dropdown>
  </div>

  <div class="ts-action">
    <span class="label">HLS Edge Server: </span>

    <icn-dropdown
      [large]="true"
      [allowMultiple]="false"
      [(selectedValue)]="channelInfo.hlsPreviewEdgeServerId"
    >
      <icn-dropdown-item
        *ngFor="let edgeServer of relevantFeedPreviewEdgeServers"
        [value]="edgeServer.id"
        [title]="edgeServer.name"
      >
      </icn-dropdown-item>
    </icn-dropdown>
  </div>

  <div class="ts-action">
    <span class="label">Future Preview Edge Server: </span>

    <icn-dropdown
      [large]="true"
      [allowMultiple]="false"
      [(selectedValue)]="channelInfo.futurePreviewEdgeServerId"
    >
      <icn-dropdown-item
        *ngFor="let edgeServer of allSystemEdgeServers"
        [value]="edgeServer.id"
        [title]="edgeServer.name"
      >
      </icn-dropdown-item>
    </icn-dropdown>
  </div>
</div>
